<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img
            src="img/avatars/avatar_user.png"
            class="c-avatar-img "
          />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader
      tag="div"
      class="text-center"
      color="light">
      <strong>Meus Dados</strong>
    </CDropdownHeader>
    <CDropdownItem @click="getClienteInformacao">
      <CIcon name="cil-user" /> {{this.razao_social}}
    </CDropdownItem>
    <CDropdownDivider/>
    <CDropdownItem @click="logout">
      <CIcon name="cil-lock-locked" /> Sair
    </CDropdownItem>
    <b-modal
      id="informacao_cliente"
      header-bg-variant="info"
      title="Meus Dados"
      size="lg" 
      hide-footer>

      <b-container fluid>
        <b-row cols="12">
          <b-col sm="12" md="12" lg="6" xl="6">
            <label>Nome</label>
            <b-input 
              v-model="razao_social"
              disabled/>            
          </b-col>
          <b-col sm="12" md="12" lg="6" xl="6">
            <label>Fantasia</label>
            <b-input 
              v-model="cliente.FANTASIA"
              disabled/>            
          </b-col>
          <b-col sm="12" md="12" lg="6" xl="6">
            <label>CPF / CNPJ</label>
            <the-mask
              v-model="cliente.CNPJ_CPF"
              :mask="['###.###.###-##','##.###.###/####-##']"
              :class="'form-control'"
              disabled/>
          </b-col>
          <b-col sm="12" md="12" lg="6" xl="6">
            <label>IE / RG</label>
            <b-input 
              v-model="cliente.INSC_RG"
              disabled/>            
          </b-col>
          <b-col sm="12" md="12" lg="6" xl="6">
            <label>CEP</label>
            <the-mask
              v-model="cliente.CEP"
              :mask="['#####-###']"
              :class="'form-control'"
              disabled/>
          </b-col>
          <b-col sm="12" md="12" lg="6" xl="6">
            <label>Logradouro</label>
            <b-input 
              v-model="cliente.LOGRADOURO"
              disabled/>            
          </b-col>
          <b-col sm="12" md="12" lg="6" xl="6">
            <label>Número</label>
            <b-input 
              v-model="cliente.NUMERO"
              disabled/>            
          </b-col>
          <b-col sm="12" md="12" lg="6" xl="6">
            <label>Complemento</label>
            <b-input 
              v-model="cliente.COMPLEMENTO"
              disabled/>            
          </b-col>
          <b-col sm="12" md="12" lg="6" xl="6">
            <label>Bairro</label>
            <b-input 
              v-model="cliente.BAIRRO"
              disabled/>            
          </b-col>
          <b-col sm="12" md="12" lg="6" xl="6">
            <label>Cidade</label>
            <b-input 
              v-model="cliente.CIDADE"
              disabled/>            
          </b-col>
          <b-col sm="12" md="12" lg="6" xl="6">
            <label>Telefone</label>
            <b-input 
              v-model="cliente.FONE"
              disabled/>            
          </b-col>
          <b-col sm="12" md="12" lg="6" xl="6">
            <label>Celular</label>
            <b-input 
              v-model="cliente.CELULAR"
              disabled/>            
          </b-col>
          <b-col sm="12" md="12" lg="6" xl="6">
            <label>E-mail</label>
            <b-input 
              v-model="cliente.EMAIL"
              disabled/>            
          </b-col>
        </b-row>
      </b-container>
                
    </b-modal>
  </CDropdown>
  
</template>

<script>

import settings from "@/settings";
import ClienteServices from "@/services/Cliente";
import utilServices from "@/services/Util";
import { TheMask } from "vue-the-mask";
import { version } from "../../package.json";

export default {

  name: 'TheHeaderDropdownAccnt',

  components: {
    TheMask,    
  },

  data () {
    return { 
      razao_social: "",
      cliente: {
        ID: null,
        NOME: "",
        FANTASIA: "",
        CNPJ_CPF: "",
        INSC_RG: "",
        LOGRADOURO: "",
        NUMERO: "",
        COMPLEMENTO: "",
        BAIRRO: "",
        CIDADE: "",
        CEP: "",
        FONE: "",
        CELULAR: "",
        EMAIL: ""
      },
    }
  },

  beforeMount: function() {
    settings.usuarioAutenticado = JSON.parse(localStorage.getItem("user_sysped"));
    settings.versao = localStorage.getItem("version_sysped");
    if (settings.versao == null) {
      localStorage.setItem("version_sysped", version);
      window.location.reload();
    } else {
      if (settings.versao != version) {
        localStorage.setItem("version_sysped", version);
        window.location.reload();      
      }
    }

    if ((settings.usuarioAutenticado == null) || (settings.usuarioAutenticado.EMPRESA == 0)) {
      this.$router.push({path: settings.routes.login});
    } else {
      this.razao_social = settings.usuarioAutenticado.RAZAO_SOCIAL;
    }
  },

  methods: {
    logout() {
      localStorage.removeItem("user_sysped");      
      this.$router.push({path: settings.routes.login});      
    },

    getClienteInformacao: function() {
      let loader = this.$loading.show({});
      ClienteServices.get()
        .then((response) => {
          if (response.status === 200) {
            if (response.data.RET == "1") {              
              this.cliente = response.data.OBJ[0];
              this.$bvModal.show("informacao_cliente");
            } else {
              this.$root.$bvToast.toast(response.data.OBJ[0].MSG, {
                title: "Erro",
                variant: "danger",
                solid: true,
              });
            }
          }
        })
        .catch((error) => {
          utilServices.parseServerError(error, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>